// Permissões e módulo do CBM de Cercas Virtuais.
//
// Ids de permissão conforme o card MK-19743 (prefixo `mobile/`, a feature vive em
// "Aplicativo") — devem bater com o platform-user-microservice (MK-19730).
// TODO(MK-19730): confirmar a CHAVE DO MÓDULO em getAllowedModules() (aqui: `cercas_virtuais`).
export const CERCAS_MODULE = 'cercas_virtuais'

export const CERCAS_PERMISSION_VIEW = 'mobile/cercas_virtuais/visualizar' // "Acesso"
export const CERCAS_PERMISSION_MANAGE = 'mobile/cercas_virtuais/gerenciar' // "Gerenciar"

// Acesso OU Gerenciar dá visualização; só Gerenciar permite criar/editar.
export const CERCAS_VIEW_ANY = [CERCAS_PERMISSION_VIEW, CERCAS_PERMISSION_MANAGE]
export const CERCAS_MANAGE_ANY = [CERCAS_PERMISSION_MANAGE]
